import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import TechStack from './components/TechStack';
import Contact from './components/Contact';
import AIChat from './components/AIChat';
import AIProjectAdvisor from './components/AIProjectAdvisor';
import WhatIDo from './components/WhatIDo';
import WebScraping from './components/WebScraping';
import ScrollToTop from './components/ScrollToTop';

const AppContent: React.FC = () => {
  const location = useLocation();
  const hideNavbar = location.pathname === '/whatido' || location.pathname === '/web-scraping';
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-light dark:bg-gray-900 transition-colors duration-300">
      <ScrollToTop />
      {!hideNavbar && <Navbar />}
      <Routes>
        <Route path="/" element={
          <>
            <Hero />
            <About />
            <Portfolio />
            <section id="ai-project-advisor" className="container mx-auto px-4 py-16">
              <AIProjectAdvisor />
            </section>
            <Services />
            <TechStack />
            <Contact />
            <AIChat />
          </>
        } />
        <Route path="/whatido" element={<WhatIDo />} />
        <Route path="/web-scraping" element={<WebScraping />} />
      </Routes>

    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App; 